const dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue')
const database = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/admin-tab.vue')
const iframe = () => import(/* webpackChunkName: "dashboard" */ '@/views/iframe/index.vue')
const boardManage = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/board-management/index.vue')
export default [
  {
    path: '/default-board',
    name: 'default-board',
    meta: {
      name: '默认数据看板',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "dashboard" */"@/views/dashboard/index.vue")
  },

  {
    path: '/person-board',
    name: 'person-board',
    meta: {
      name: '个人文件夹',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "dashboard" */"@/views/dashboard/index.vue")
  },
  {
    path: '/person-board-main',
    name: 'person-board-main',
    meta: {
      name: '个人文件夹',
      parentsName: 'person-board-customer',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index.vue")
  },
  {
    path: '/data-board-main',
    name: 'data-board-main',
    meta: {
      name: '数据看板',
      parentsName: 'data-board-customer',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/dashboard/index.vue"], resolve)
  },
  {
    path: '/admin-config',
    name: 'admin-config',
    meta: {
      name: '后台管理',
      keepAlive: true
    },
    component: database
  },
  {
    path: '/big-screen',
    name: 'big-screen',
    meta: {
      name: '大屏看板',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/pearlgo-screen',
    name: 'pearlgo-screen',
    meta: {
      name: 'Pearlgo数据看板',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/mw-screen',
    name: 'mw-screen',
    meta: {
      name: 'MW数据看板',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/rl-screen',
    name: 'rl-screen',
    meta: {
      name: 'RL数据看板',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/gl-screen',
    name: 'gl-screen',
    meta: {
      name: 'GL数据看板',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/rl-day-board',
    name: 'rl-day-board',
    meta: {
      name: '经营日报',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/rl-market-board',
    name: 'rl-market-board',
    meta: {
      name: '营销分析',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/day-board',
    name: 'day-board',
    meta: {
      name: 'Pearlgo经营日报',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/mw-day-board',
    name: 'mw-day-board',
    meta: {
      name: 'MW经营日报',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/gl-day-board',
    name: 'gl-day-board',
    meta: {
      name: 'GL经营日报',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/market-board',
    name: 'market-board',
    meta: {
      name: '营销分析',
      keepAlive: true,
      notLayout: true
    },
    component: (resolve) => require(["@/views/iframe/index.vue"], resolve)
  },
  {
    path: '/board-management',
    name: 'board-management',
    meta: {
      name: '公共看板管理',
      keepAlive: true,
      notLayout: true
    },
    component: boardManage
  },
  {
    path: '/board-center-setting',
    name: 'board-center-setting',
    meta: {
      name: '公共看板管理',
      keepAlive: true,
      notLayout: true
    },
    component: boardManage
  },
  {
    path: '/personal-board-setting',
    name: 'personal-board-setting',
    meta: {
      name: '个人报表管理',
      keepAlive: true,
      notLayout: true
    },
    component: boardManage
  },
  {
    path: '/data-board',
    name: 'data-board',
    meta: {
      name: '数据看板',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index.vue")
  },
  {
    path: '/iframe-board',
    name: 'iframe-board',
    meta: {
      name: '第三方链接',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/iframe/index.vue")
  },
  {
    path: '/screen-board',
    name: 'screen-board',
    meta: {
      name: '大屏看板',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/big-screen/index.vue')
  },
  {
    path: '/sale-area',
    name: 'sale-area',
    meta: {
      name: '区域售卖分析',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "dashboard" */ '@/views/big-screen/sale-area.vue')
  }
]
